import {Component, forwardRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

export const PhotoLayouts = [
    [
        '"a"'
    ],
    [
        '"a b"',
        '"a" "b"'
    ],
    [
        '"a b c"',
        '"a" "b" "c"',
        '"a b" "a c"',
        '"a c" "b c"',
        '"a a" "b c"',
        '"a b" "c c"'
    ],
    [
        '"a a a" "b c d"',
        '"a b c" "d d d"',
        '"a a b" "c d d"',
        '"a b b" "c c d"',
        '"a a b" "c c d"',
        '"a b b" "c d d"',
        '"a b" "c d"'
    ],
    [
        '"a a b" "c d e"',
        '"a b b" "c d e"',
        '"a b c" "d d e"',
        '"a b c" "d e e"',
    ]
];

export type PhotoLayoutsAvailable = typeof PhotoLayouts[number];
export type PhotoLayout = typeof PhotoLayouts[number][number];

@Component({
    selector: 'app-select-photo-layout',
    templateUrl: './select-photo-layout.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectPhotoLayoutComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SelectPhotoLayoutComponent implements ControlValueAccessor, OnChanges {
    @Input() totalPhotosSelected = 0;

    availableLayouts: PhotoLayoutsAvailable | undefined = undefined;
    selectedLayout: PhotoLayout | undefined = undefined;

    onChange = (layout: PhotoLayout | undefined) => {}
    onTouched = () => {}

    ngOnChanges() {
        this.availableLayouts = PhotoLayouts[this.totalPhotosSelected - 1];

        if (this.selectedLayout) {
            this.selectLayout(undefined);
        }
    }

    selectLayout(layout: PhotoLayout | undefined) {
        this.selectedLayout = layout;
        this.onChange(layout);
        this.onTouched();
    }

    registerOnChange(fn: (value: PhotoLayout | undefined) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    writeValue(obj: PhotoLayout): void {
        this.selectedLayout = obj;
    }
}
